<template>
  <div class="card width-100" id="dynamic-fields-table">
    <div class="card-body table-responsive table-full-width">
      <el-table class="table-striped"
                :data="sortedFields"
                row-key="label"
                border
                row-class-name="draggable"
                id="task-type-field-table"
                style="width: 100%;">
        <el-table-column v-for="column in tableColumns"
                         :key="column.label"
                         :min-width="column.minWidth"
                         :prop="column.prop"
                         :label="column.label">
        </el-table-column>
        <el-table-column
          min-width="100"
          label="Active">
          <template slot-scope="props">
            {{props.row.active | printBool}}
          </template>
        </el-table-column>
        <el-table-column
          width="110"
          fixed="right"
          label="Actions">
          <template slot-scope="props">
            <p-button type="success" size="sm" icon>
              <i class="fa fa-edit" @click="handleShowModal(props.row)"></i>
            </p-button>
            <p-button type="danger" size="sm" icon :disabled="fieldInUse(props.row.key)" @click="handleDelete(props.row)">
              <i class="fa fa-times"></i>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import PButton from '@/components/UIComponents/Button'
  import Sortable from 'sortablejs'
  import cheerio from 'cheerio'

  export default {
    components: {
      PButton
    },
    mounted() {
      const table = document.querySelector('#dynamic-fields-table .el-table__body-wrapper tbody')
      const self = this // usually not necessary but commit below wouldn't work otherwise
      Sortable.create(table, {
        dataIdAttr: 'label',
        onEnd() {
          let sort = 1
          const sortedFields = {}
          for (let i = 0; i < table.rows.length; i++) {
            const $ = cheerio.load(table.rows[i].cells[1].innerHTML)
            const property = $('div').text()
            sortedFields[property] = sort
            sort++
          }
          self.$store.commit('tasks/templates/editFieldsSort', sortedFields)
        }
      })
    },
    computed: {
      ...mapGetters({
        sortedFields: 'tasks/templates/editSortedFields'
      })
    },
    data() {
      return {
        tableColumns: [
          {
            prop: 'label',
            label: 'Label',
            minWidth: 105
          },
          {
            prop: 'key',
            label: 'Key',
            minWidth: 95
          },
          {
            prop: 'component',
            label: 'Field Type',
            minWidth: 75
          }
        ]
      }
    },
    methods: {
      fieldInUse(key) {
        return this.$store.getters['tasks/templates/fieldInUse'](key)
      },
      handleShowModal(field) {
        this.$eventHub.$emit('show-modal-2', 'Task Field', field, '45%')
      },
      handleDelete(row) {
        this.$store.commit('tasks/templates/editFieldsRemove', row)
      }
    }
  }
</script>
<style scoped>
  .card {
    box-shadow: none;
  }
</style>
